import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { images } from '../../../Constants/ImageUrls';
import AnywhereHorizontalScroll from '../../HelperComponents/AnywhereHorizontalScroll';
import {
  BlackEighty,
  ProductColorContainer,
  ProductColorCover,
  ProductColorUl,
} from './styled';
import ProductColorInner from './ProductColorInner';
import DiaperSizeBoxes from '../SizeBoxes/DiaperSizeBoxes';
import {
  maternityBraSkuList,
  maternitySkusList,
} from '../../Product/OfferCarousel/constant';
import Cookies from 'js-cookie';
import LactomamaFlavourBoxes from '../SizeBoxes/LactomamaFlavourBoxes';

export default function ProductColor(props) {
  const {
    varientData,
    clickProductColorHandler,
    varientTitle,
    selectedData,
    productDetail,
    showNewDiaperVariantUx,
    isVariantPopup,
    handleClose,
    showNewLactomamaVariantUx,
    updateVariant,
    setUserSelectedVariant,
    setSelectedVariant,
    userSelectedVariant,
    setUpdateVariant,
    packsCount,
    showCDNewVariantUx,
    tabThemeColor,
    


  } = props;
  const key = 'title';
  const varientArray = [...varientData];

  const [focusElement, setFocusElement] = useState();
  const customReducerState = selectedData;
  const variantOptions = productDetail?.variantOption;
  const notSingleVariant = variantOptions?.length > 1;

  const [arrayUniqueByKey, setArrayUniqueByKey] = useState([]);

  useEffect(() => {
    varientArray.reverse();
    const array = [
      ...new Map(
        varientArray
          .filter(
            (item) =>
              item.title !== 'Travel Pack' && item.title !== 'Mini Pack',
          )
          .map((item) => [item[key], item]),
      ).values(),
    ];

    setArrayUniqueByKey(array);
    Cookies.set('variantSize', array.length);

    if (
      maternityBraSkuList.includes(parseInt(productDetail?.id)) ||
      maternitySkusList.includes(parseInt(productDetail?.id)) ||
      [3878].includes(parseInt(productDetail?.variant_id))
    ) {
      const selectedDataString = localStorage.getItem('selectedVariant');
      const currentVariant = JSON.parse(selectedDataString);

      let selectedSize =
        currentVariant?.['SIZE'] || currentVariant?.['FLAVOUR'];
      if (!selectedSize) {
        for (const variant of variantOptions) {
          if (variant.variant_type != varientTitle) {
            for (const data of variant.data) {
              if (productDetail?.id == data.product_id) {
                selectedSize = data.title;
              }
            }
          }
        }
      }

      let commonSizeIds = [];

      for (const variant of variantOptions) {
        if (variant.variant_type != varientTitle) {
          for (const data of variant.data) {
            if (data.title == selectedSize) {
              commonSizeIds.push(data.product_id);
            }
          }
        }
      }

      const finalArr = [];
      for (const variant of variantOptions) {
        if (variant.variant_type == varientTitle) {
          for (const data of variant.data) {
            if (commonSizeIds.includes(data.product_id)) {
              finalArr.push(data);
            }
          }
        }
      }

      if ([3878].includes(parseInt(productDetail?.variant_id))) {
        finalArr?.forEach((variant) => {
          // switch (variant.product_id) {
          //   case 3946:
          //     variant.variantFeature = [
          //       {
          //         feature: '1 Bottle (300g)',
          //         featureHi: '',
          //       },
          //     ];
          //     variant.ppuText = `₹${Math.floor((variant.price * 100) / 300)}`;
          //     // variant.subText = "Chocolate";
          //     // variant.title = "15 Day Pack";
          //     break;
          //   case 3878:
          //     variant.variantFeature = [
          //       {
          //         feature: '1 Bottle (300g)',
          //         featureHi: '',
          //       },
          //     ];
          //     variant.ppuText = `₹${Math.floor((variant.price * 100) / 300)}`;
          //     // variant.subText = "Elaichi";
          //     // variant.title = "15 Day Pack";
          //     break;
          //   case 4097:
          //   case 4095:
          //     variant.variantFeature = [
          //       {
          //         feature: '2 Bottles (600g)',
          //         featureHi: '',
          //       },
          //     ];
          //     variant.ppuText = `₹${Math.floor((variant.price * 100) / 600)}`;
          //     // variant.subText = "Chocolate";
          //     // variant.title = "30 Day Pack";
          //     break;
          //   case 3928:
          //     variant.variantFeature = [
          //       {
          //         feature: '2 Bottles (600g)',
          //         featureHi: '',
          //       },
          //     ];
          //     variant.ppuText = `₹${Math.floor((variant.price * 100) / 600)}`;
          //     // variant.subText = "Elaichi";
          //     // variant.title = "30 Day Pack";
          //     break;
          //   case 4098:
          //   case 4096:
          //     variant.variantFeature = [
          //       {
          //         feature: '4 Bottles (1.2kg)',
          //         featureHi: '',
          //       },
          //     ];
          //     variant.ppuText = `₹${Math.floor((variant.price * 100) / 1200)}`;
          //     // variant.subText = "Chocolate";
          //     // variant.title = "60 Day Pack";
          //     break;
          //   case 3929:
          //     variant.variantFeature = [
          //       {
          //         feature: '4 Bottles (1.2kg)',
          //         featureHi: '',
          //       },
          //     ];
          //     variant.ppuText = `₹${Math.floor((variant.price * 100) / 1200)}`;
          //     // variant.subText = "Elaichi";
          //     // variant.title = "60 Day Pack";
          //     break;
          //   default:
          //     break;
          // }

          switch (variant.product_id) {
            case 3946:
              variant.variantFeature = [
                {
                  feature: '1 Bottle (300g)',
                  featureHi: '',
                },
              ];
              variant.ppuText = `₹${Math.floor((variant.price * 100) / 300)}`;
              // variant.subText = 'Chocolate';
              variant.title = '15 Days Pack';
              break;
            case 3963:
              variant.variantFeature = [
                {
                  feature: '1 Bottle (300g)',
                  featureHi: '',
                },
              ];
              variant.ppuText = `₹${Math.floor((variant.price * 100) / 300)}`;
              // variant.subText = 'Kesar Badam';
              variant.title = '15 Days Pack';
              break;
            case 3878:
              variant.variantFeature = [
                {
                  feature: '1 Bottle (300g)',
                  featureHi: '',
                },
              ];
              variant.ppuText = `₹${Math.floor((variant.price * 100) / 300)}`;
              //  variant.subText = 'Elaichi';
              variant.title = '15 Days Pack';
              break;
            case 4095:
              variant.variantFeature = [
                {
                  feature: '2 Bottles (600g)',
                  featureHi: '',
                },
              ];
              variant.ppuText = `₹${Math.floor((variant.price * 100) / 600)}`;
              // variant.subText = 'Chocolate';
              variant.title = '30 Days Pack';
              break;
            case 4100:
              variant.variantFeature = [
                {
                  feature: '2 Bottles (600g)',
                  featureHi: '',
                },
              ];
              variant.ppuText = `₹${Math.floor((variant.price * 100) / 600)}`;
              // variant.subText = 'Kesar Badam';
              variant.title = '30 Days Pack';
              break;
            case 3928:
              variant.variantFeature = [
                {
                  feature: '2 Bottles (600g)',
                  featureHi: '',
                },
              ];
              variant.ppuText = `₹${Math.floor((variant.price * 100) / 600)}`;
              // variant.subText = 'Elaichi';
              variant.title = '30 Days Pack';
              break;
            case 4096:
              variant.variantFeature = [
                {
                  feature: '4 Bottles (1.2kg)',
                  featureHi: '',
                },
              ];
              variant.ppuText = `₹${Math.floor((variant.price * 100) / 1200)}`;
              // variant.subText = 'Chocolate';
              variant.title = '60 Days Pack';
              break;
            case 3929:
              variant.variantFeature = [
                {
                  feature: '4 Bottles (1.2kg)',
                  featureHi: '',
                },
              ];
              variant.ppuText = `₹${Math.floor((variant.price * 100) / 1200)}`;
              // variant.subText = 'Elaichi';
              variant.title = '60 Days Pack';
              break;
            case 4101:
              variant.variantFeature = [
                {
                  feature: '4 Bottles (1.2kg)',
                  featureHi: '',
                },
              ];
              variant.ppuText = `₹${Math.floor((variant.price * 100) / 1200)}`;
              // variant.subText = 'Kesar Badam';
              variant.title = '60 Days Pack';
              break;
            case 4097:
              variant.variantFeature = [
                {
                  feature: '2 Bottles (600g)',
                  featureHi: '',
                },
              ];
              variant.ppuText = `₹${Math.floor((variant.price * 100) / 600)}`;
              // variant.subText = 'Elaichi';
              variant.title = '30 Days Pack';
              break;
            case 4098:
              variant.variantFeature = [
                {
                  feature: '4 Bottles (1.2kg)',
                  featureHi: '',
                },
              ];
              variant.ppuText = `₹${Math.floor((variant.price * 100) / 1200)}`;
              // variant.subText = 'Kesar Badam';
              variant.title = '60 Days Pack';
              break;

            default:
              break;
          }
        });
      }
      setArrayUniqueByKey(finalArr);
      Cookies.set('variantSize', arrayUniqueByKey.length);
    }
  }, [varientData, updateVariant]);

  const applyGestureEffect = (index) => {
    setFocusElement(index);
    setTimeout(() => {
      setFocusElement(null);
    }, 350);
  };
  const productClickHandler = (
    customReducerState = [],
    variantOptions = [],
    fallbackId,
    variantDetails,
  ) => {
    let shortListedItem = [];
    const combinedState = { ...customReducerState, ...variantDetails };
    let selectedElement = {};
    variantOptions.forEach((item, index) => {
      let outterIndex = index;
      item.data.forEach((data) => {
        if (
          data.title == combinedState[item?.variant_type?.toUpperCase()] &&
          outterIndex === 0
        ) {
          shortListedItem.push(data.web_url);
        } else if (
          data.title != combinedState[item?.variant_type?.toUpperCase()] &&
          outterIndex != 0
        ) {
          let indexValue = shortListedItem.indexOf(data.web_url);
          if (indexValue > -1) {
            shortListedItem.splice(indexValue, 1);
          }
        }
        const indexOfResult = item.data.findIndex(
          (i) => i.web_url == shortListedItem.toString(),
        );
        selectedElement = item.data[indexOfResult];
      });
    });

    clickProductColorHandler(
      shortListedItem.length > 0
        ? shortListedItem.toString()
        : fallbackId?.web_url
          ? fallbackId?.web_url
          : fallbackId?.product_id?.toString(),
      shortListedItem.length > 0 ? selectedElement : fallbackId,
      varientTitle,
      combinedState[varientTitle.toUpperCase()],
    );

    if (isVariantPopup) {
      handleClose();
    }
  };
  const productColorClickHandler = (element) => {
    const variantDetails = {};
    variantDetails['productId'] = element?.product_id;
    variantDetails[varientTitle.toUpperCase()] = element?.title;
    variantDetails['SizesAvailable'] = varientData.map((item) => {
      if (item?.title === element?.title) return item?.product_id;
    });
    productClickHandler(
      customReducerState,
      variantOptions,
      element,
      variantDetails,
    );
  };
  useEffect(() => {
    arrayUniqueByKey?.map((element, index) => {
      if (customReducerState[varientTitle.toUpperCase()] == element?.title) {
        const myElement = document?.getElementById(`${element.name + index}`);

        function getOffset(el) {
          let _x = 0;
          let _y = 0;
          while (el && !isNaN(el?.offsetLeft) && !isNaN(el?.offsetTop)) {
            _x += el?.offsetLeft - el?.scrollLeft;
            _y += el?.offsetTop - el?.scrollTop;
            el = el.offsetParent;
          }
          return { top: _y, left: _x };
        }

        let x = getOffset(myElement).left;
        if (document.getElementById(`colorBoxOutter`)) {
          document.getElementById(`colorBoxOutter`).scrollLeft = x - 30;
        }
      }
    });
  }, [selectedData]);


     const getVariantTitle = (variantType) => {
    if (showNewLactomamaVariantUx) {
      return `Select ${variantType}`;
    }
    return variantType;
  };

  return showNewLactomamaVariantUx ? (
    <ProductColorContainer>
      {!isVariantPopup && (
        <ProductColorCover>
          <span className="head">{getVariantTitle(varientTitle)} :&nbsp;</span>
          <BlackEighty tabThemeColor={tabThemeColor}>    
            {customReducerState[varientTitle.toUpperCase()]}
          </BlackEighty>
        </ProductColorCover>
      )}

      <ProductColorUl
        notSingleVariant={notSingleVariant}
        id="colorBoxOutter"
        showNewDiaperVariantUx={showNewDiaperVariantUx}
      >
        {arrayUniqueByKey?.map((element, index) => {
          if (element?.title != 'Mini Pack' && element?.title != 'Travel Pack')
            return showNewDiaperVariantUx || showCDNewVariantUx ? (
              <DiaperSizeBoxes
                sizeClickHandler={productColorClickHandler}
                varientTitle={varientTitle}
                showNewDiaperVariantUx={showNewDiaperVariantUx}
                showCDNewVariantUx={showCDNewVariantUx}
                element={element}
                index={index}
                focusElement={focusElement}
                selectedSize={customReducerState[varientTitle.toUpperCase()]}
                packsCount={packsCount}
              />
            ) : showNewLactomamaVariantUx ? (
              <LactomamaFlavourBoxes
                sizeClickHandler={productColorClickHandler}
                varientTitle={varientTitle}
                element={element}
                index={index}
                focusElement={focusElement}
                selectedSize={customReducerState[varientTitle.toUpperCase()]}
                setUserSelectedVariant={setUserSelectedVariant}
                setSelectedVariant={setSelectedVariant}
                userSelectedVariant={userSelectedVariant}
                setUpdateVariant={setUpdateVariant}
                updateVariant={updateVariant}
              />
            ) : (
              <ProductColorInner
                productColorClickHandler={productColorClickHandler}
                element={element}
                varientTitle={varientTitle}
                index={index}
                arrayUniqueByKey={arrayUniqueByKey}
                focusElement={focusElement}
                customReducerState={customReducerState}
                notSingleVariant={notSingleVariant}
                applyGestureEffect={applyGestureEffect}
              />
            );
        })}
      </ProductColorUl>
    </ProductColorContainer>
  ) : (
    <ProductColorContainer>
      {!isVariantPopup && (
        <ProductColorCover>
          <span className="head">{varientTitle}:&nbsp;</span>
          <BlackEighty>
            {customReducerState[varientTitle.toUpperCase()]}
          </BlackEighty>
        </ProductColorCover>
      )}

      <ProductColorUl
        notSingleVariant={notSingleVariant}
        id="colorBoxOutter"
        showNewDiaperVariantUx={showNewDiaperVariantUx}
      >
        <AnywhereHorizontalScroll
          firstElementId={`${arrayUniqueByKey[0]?.title}first`}
          lastElementId={`${
            arrayUniqueByKey[arrayUniqueByKey?.length - 1]?.title
          }last`}
          leftArrow={<img src={images.arrowdownforward} alt="" />}
          rightArrow={<img src={images.arrowdownforward} alt="" />}
          scrolledWidth={440}
        >
          {arrayUniqueByKey?.map((element, index) => {
            if (
              element?.title != 'Mini Pack' &&
              element?.title != 'Travel Pack'
            )
              return showNewDiaperVariantUx || showCDNewVariantUx ? (
                <DiaperSizeBoxes
                  sizeClickHandler={productColorClickHandler}
                  varientTitle={varientTitle}
                  showNewDiaperVariantUx={showNewDiaperVariantUx}
                  showCDNewVariantUx={showCDNewVariantUx}
                  element={element}
                  index={index}
                  focusElement={focusElement}
                  selectedSize={customReducerState[varientTitle.toUpperCase()]}
                  packsCount={packsCount}
                />
              ) : showNewLactomamaVariantUx ? (
                <LactomamaFlavourBoxes
                  sizeClickHandler={productColorClickHandler}
                  varientTitle={varientTitle}
                  element={element}
                  index={index}
                  focusElement={focusElement}
                  selectedSize={customReducerState[varientTitle.toUpperCase()]}
                  setUserSelectedVariant={setUserSelectedVariant}
                  setSelectedVariant={setSelectedVariant}
                  userSelectedVariant={userSelectedVariant}
                  setUpdateVariant={setUpdateVariant}
                  updateVariant={updateVariant}
                />
              ) : (
                <ProductColorInner
                  productColorClickHandler={productColorClickHandler}
                  element={element}
                  varientTitle={varientTitle}
                  index={index}
                  arrayUniqueByKey={arrayUniqueByKey}
                  focusElement={focusElement}
                  customReducerState={customReducerState}
                  notSingleVariant={notSingleVariant}
                  applyGestureEffect={applyGestureEffect}
                />
              );
          })}
        </AnywhereHorizontalScroll>
      </ProductColorUl>
    </ProductColorContainer>
  );
}

